import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import FormEdit from '../../../../../components/auth/educacao/documentos/listar/form_edit'
import Head from '../../../../../components/head'


function EditarDocumentoEducacaoScreen () {
    return (
        <Fragment>
            <Head titulo="Editando Documento da Secretaria Municipal de Educação" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
        </Fragment>
    );
}

export default EditarDocumentoEducacaoScreen;